import React, { useCallback, useEffect, useRef, useState } from 'react'
import './MonthlyHistory.css'
import { Button, Checkbox, Col, Dropdown, Menu, Radio, Row, Table } from 'antd'
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import images1 from '../../assets/images1.jfif'
import { useSelector } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { BASE_URL, FetchDepartment, FetchDesignation, FetchStaff, STAFF_ROLE, UpdateStaff } from '../../utils/constant'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { FaAngleDown } from "react-icons/fa6";
import FilterIcon from '../../assets/icons/filter-box.svg'
import SearchIcon from '../../assets/icons/search.svg'
function MonthlyHistory() {
    const gridRef = useRef();

    const [size, setSize] = useState("july");
    const userInfo = useSelector((state) => state.signUp.signUpDetails);
    const designationState = useSelector((state) => state.designation.designation);
    const departmentState = useSelector((state) => state.department.department);
    const [staffDetail, setStaffDetail] = useState(departmentState);
    const [departments, setDepartments] = useState(designationState);
    const [designations, setDesignations] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        designation: [],
        department: [],
      });
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
      };
      const gridOptions = {
        getRowClass: params => {
            if (params.node.rowIndex % 2 !== 0) {
                return 'RowColor';
            }
        },
    
    }
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
  
    const currentMonth = currentDate.getMonth() + 1; 
    const currentYearSelected = currentDate.getFullYear();
  
    const [selectedMonthNumber, setSelectedMonthNumber] = useState(currentMonth);
    const [selectedYearNumber, setSelectedYearNumber] = useState(currentYearSelected);
    const BoCreatedAt = userInfo?.userRole == "businessOwner" ? userInfo?.createdAt : userInfo?.boOwner?.createdAt;

    const dynamicDate = new Date(BoCreatedAt);
     
    let endYear;
      
      if (currentMonth < 4) {
          endYear = currentYear -1;
      } else {
          endYear = currentYear;
      }
      
      const startYear = dynamicDate.getMonth() < 3 ? dynamicDate.getFullYear() - 1 : dynamicDate.getFullYear();
      const numberOfYears = endYear - startYear + 1;
      
      const fiscalYear = Array.from({ length: numberOfYears }, (_, index) => {
          const year = startYear + index;
          return `${year}-${year + 1}`;
      });
      
      const defaultSelectedMonth = `${currentMonth < 10 ? '' : ''}${currentMonth}-${currentYear}`;
  
      const [selectedMonth, setSelectedMonth] = useState(defaultSelectedMonth);
  
      const currentFiscalYear = `${currentYear}-${currentYear + 1}`;
      const defaultSelectedFiscalYear = fiscalYear.includes(currentFiscalYear) ? currentFiscalYear : fiscalYear[0];
      const [selectedFiscalYea, setSelectedFiscalYea] = useState(defaultSelectedFiscalYear);
  
    const updateMonths = (selectedYear) => {
      const startYear = parseInt(selectedYear.split('-')[0]);
      const endYear = parseInt(selectedYear.split('-')[1]);
    
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // Adding 1 to convert from 0-indexed to 1-indexed
      const dynamicMonth = dynamicDate.getMonth() + 1; 
      const months = [];
      if(startYear == dynamicDate.getFullYear()){
        for (let month = dynamicMonth; month <= 12; month++) {
          if (startYear < currentYear || (startYear === currentYear && month <= currentMonth)) {
            months.push(`${month < 10 ? '' : ''}${month}-${startYear}`);
          }
        }
      
        for (let month = 1; month <= 3; month++) {
          if (endYear < currentYear || (endYear === currentYear && month <= currentMonth)) {
            months.push(`${month < 10 ? '' : ''}${month}-${endYear}`);
          }
        }
      }else if(endYear == dynamicDate.getFullYear()){
        for (let month = dynamicMonth; month <= 3; month++) {
          if (endYear < currentYear || (endYear === currentYear && month <= currentMonth)) {
            months.push(`${month < 10 ? '' : ''}${month}-${endYear}`);
          }
        }
      }else{
  
        for (let month = 4; month <= 12; month++) {
          if (startYear < currentYear || (startYear === currentYear && month <= currentMonth)) {
            months.push(`${month < 10 ? '' : ''}${month}-${startYear}`);
          }
        }
        
        for (let month = 1; month <= 3; month++) {
          if (endYear < currentYear || (endYear === currentYear && month <= currentMonth)) {
            months.push(`${month < 10 ? '' : ''}${month}-${endYear}`);
          }
        }
      }
    
      return months;
    };
   
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const getMonthName = (monthNumber) => {
      
  
      if (monthNumber >= 1 && monthNumber <= 12) {
        return monthNames[monthNumber - 1];
      } else {
        return 'Invalid Month';
      }
    };
    const handleFiscalYearChang = (event) => {
      const newFiscalYear = event.target.value;
      setSelectedFiscalYea(newFiscalYear);
      setSelectedMonth(null);
    };
  
    const handleMonthChange = (event) => {
      const selectedMonthValu = event.target.value;
      setSelectedMonth(selectedMonthValu);
      const [selectedMonthNumberEvent, selectedYearNumberEvent] = selectedMonthValu.split('-');
      setSelectedMonthNumber(selectedMonthNumberEvent)
      setSelectedYearNumber(selectedYearNumberEvent)
    };
    const handleFiscalYearChan = (year) => {
      setSelectedFiscalYea(year);
      setSelectedMonth(null);
    };
    const fiscalYearMenu = (
      <Menu onClick={(e) => handleFiscalYearChan(e.key)}>
        {fiscalYear?.map((year) => (
          <Menu.Item key={year}>
            {year}
          </Menu.Item>
        ))}
      </Menu>
    );
    const handleSizeChange = (e) => {
        setSize(e.target.value);
    };

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
          'quickFilterText',
          document.getElementById('filter-text-box').value
        );
      }, []);
    const handleMenuClick = (e) => {
        let updatedFilter;
        if(e.keyPath[1] == "designation"){
          updatedFilter = {designation : e.keyPath[0]}
  
      }else if(e.keyPath[1] == "department"){
          updatedFilter = {department : e.keyPath[0]}
  
          }
          getStaffList(updatedFilter);
      };
    
      const menu = (
        <Menu onClick={handleMenuClick}>
          <Menu.SubMenu key="department" title="Department">
            {departments?.map((department) => (
              <Menu.Item key={department.key}>{department.value}</Menu.Item>
            ))}
          </Menu.SubMenu>
          <Menu.SubMenu key="designation" title="Designation">
            {designations?.map((designation) => (
              <Menu.Item key={designation.key}>{designation.value}</Menu.Item>
            ))}
          </Menu.SubMenu>
        </Menu>
      );

    useEffect(() => {
        getStaffList();
        // getDepartmentList();
        // getDesignationList()
      }, [selectedFilters]);
      const getDesignationList = async () =>{
        const token = localStorage.getItem('authToken');

        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeDesignation = data.data.filter(item => item.isActive);
                const newArray = activeDesignation?.map((item) => ({
                    value: item.designationName,
                    key: item.designationId
                  }));
                 setDesignations(newArray)
              
              } else {
                const data = await response.json();
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const getDepartmentList = async () =>{
        const token = localStorage.getItem('authToken');
      
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeDepartment = data.data.filter(item => item.isActive);
                const newArray = activeDepartment?.map((item) => ({
                    value: item.departmentName,
                    key: item.departmentId
                  }));
                 setDepartments(newArray)
              
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const getStaffList = async (updatedFilter) =>{
        const token = localStorage.getItem('authToken');
        const filtersToSend = Object.fromEntries(
            Object.entries(selectedFilters).filter(([_, value]) => value.length > 0)
        );
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify(filtersToSend ),
              });
              
              if (response.ok) {
                const data = await response.json();
               setStaffDetail(data.data)
              
              } else {
                const data = await response.json();
                console.log('stafferr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }

    const columnDefs = [{
        headerName: 'Name',
        field:'profile',
        flex: 1,
        cellRenderer: (params) => {
          return(
            <>
            <div className='flex items-center'>
              <div className='w-10 h-10 overflow-hidden rounded-full flex items-center justify-center'>
                <img
                  className='w-full h-full object-cover'
                  src={params?.data?.item?.logo}
                  alt=''
                />
              </div>
              <div className='text-[15px] leading-none pl-2'>
                <div className='font-sbold'>{capitalizeFirstLetter(params?.data?.item?.firstName)} {capitalizeFirstLetter(params?.data?.item?.lastName)}</div>
                <div className='text-xs'>{capitalizeFirstLetter(params?.data?.item?.designation?.designationName)} | {capitalizeFirstLetter(params.data?.item?.department?.departmentName)}</div>
              </div>
            </div>
            </>
          )
        },
      },{
        headerName: 'Action Done',
        field:'profile',
        cellRenderer: (params) => {
            return(
            <>
          <div className='text-center w-full'>
            {params.data?.item?.action?.title == 'added' ?
            <p className='text-[green] font-sbold'>{capitalizeFirstLetter(params.data?.item?.action?.title)}</p>
            : params.data?.item?.action?.title == 'deactivated' ?
            <p className='text-[red] font-sbold'>{capitalizeFirstLetter(params.data?.item?.action?.title)}</p>
            : <p className=' font-sbold'>{capitalizeFirstLetter(params.data?.item?.action?.title)}</p>
            }
          </div>
          </>
            )
            },
      },
      {
        headerName: 'Action Done By',
        field:'profile',
        cellRenderer: (params) => {
            return(
            <><p className='font-sbold text-center w-full'>{capitalizeFirstLetter(params.data.item.action?.doneBy?.userName)}</p></>
            )
            },
      },
     
      
    ];

    const filters = {
        designation: designationState,
        department: departmentState,
      };
      const handleFilterMenuClick = (type, { key }) => {
        const updatedSelection = selectedFilters[type].includes(key)
          ? selectedFilters[type].filter((item) => item !== key)
          : [...selectedFilters[type], key];
        console.log("selectedFilters", selectedFilters);
        setSelectedFilters({ ...selectedFilters, [type]: updatedSelection });
      };
    
    const filterMenu = (type) => (
        <Menu onClick={(item) => handleFilterMenuClick(type, item)}>
          {filters[type]?.map((filter) => (
            <Menu.Item key={filter.key}>
              <Checkbox className='mr-1' checked={selectedFilters[type].includes(filter.key)}/>
                {filter.value}
            </Menu.Item>
          ))}
        </Menu>
      );
    const dropdownMenu = (
        <Menu>
          <Menu.SubMenu key="designation" title="Designation">
            {filterMenu("designation")}
          </Menu.SubMenu>
          <Menu.SubMenu key="department" title="Department">
            {filterMenu("department")}
          </Menu.SubMenu>
        </Menu>
      );
    const rowdata = staffDetail?.map((item, index) => {
       
        return {
          key: index,
          item: item,
          profile: item.firstName,
        
        };
      });
    
    return (
        <>
            <Row>
                <Col lg={13}>
                <div className='flex defaulTabs items-center mt-3'>
                    <Radio.Group className="radioBtnMonths !bg-[#F1F6FD]" value={selectedMonth} onChange={(e) => handleMonthChange(e)}>
                      {updateMonths(selectedFiscalYea)?.map((month) => (
                        <Radio.Button
                          key={month}
                          value={month}
                          className="text-center !px-4 !py-[5px] !rounded-[11px]"
                          style={{
                            backgroundColor: `${selectedMonth === month ? '#00305F' : '#F1F6FD'}`,
                            color: `${selectedMonth === month ? 'white' : 'black'}`,
                            borderColor: `${selectedMonth === month ? '#363743' : '#EBEBEC'}`,
                            
                          }}
                        >
                          <div className="text-[17px] font-sbold">{monthNames[parseInt(month.split('-')[0]) - 1]}</div>
                          <div className="text-[11px] font-normal leading-none">{month.split('-')[1]}</div>
                        </Radio.Button>
                      ))}
                    </Radio.Group>

                      {/* <Dropdown menu={{ items }} placement='bottom'>
                    <Button className='simple-btn1'>{selectedFiscalYear}</Button>
                  </Dropdown> */}
                  <Dropdown overlay={fiscalYearMenu} placement="bottom" className='ml-2'>
                    <Button className="bg-[#F1F6FD] border-[#F1F6FD] font-semibold h-[38px] flex items-center !pr-3 !outline-none">
                      {selectedFiscalYea}
                      <FaAngleDown className="ml-2 text-xs text-[#4B8AEB]" />
                    </Button>
                  </Dropdown>
                  <div  className='flex mt-2 ml-auto'>
                    <img src={SearchIcon} className='mr-2'/>
                    <input 
                      type="text"
                      id="filter-text-box"
                      placeholder="Search..."
                      className='border-bottom h-[38px] !border-[#B7D0F7] outline-none'
                      onInput={onFilterTextBoxChanged}
                    />
                    {/* <Dropdown className='mt-2 ml-2' overlay={menu} trigger={['click']}>
                        <div>
                        <FilterOutlined className="assign-all-search mr-1" />
                      </div>
                    </Dropdown> */}
                    <Dropdown overlay={dropdownMenu} trigger={["click"]} placement="bottom">
                      {/* <Button className="btn filterBtn">Filter</Button> */}
                      <img src={FilterIcon}  className='cursor-pointer'/>
                    </Dropdown>
                    {/* <AlignLeftOutlined className='assign-all-search' /> */}
                  </div>
                </div>
                    {/* <div className='flex defaulTabs'>
                        <Radio.Group value={size} onChange={handleSizeChange} className='flex ml-2 mt-2'>
                            <Radio.Button value="july" style={{ backgroundColor: `${size === 'july' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'july' ? 'white' : 'black'}`, borderColor: `${size === 'july' ? '#363743' : '#EBEBEC'}` }}>July <br /><span className='fort-year'>2023</span> </Radio.Button>
                            <Radio.Button value="june" style={{ backgroundColor: `${size === 'june' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'june' ? 'white' : 'black'}`, borderColor: `${size === 'june' ? '#363743' : '#EBEBEC'}` }}><p>Jun <br /><span className='fort-year'>2023</span></p></Radio.Button>
                            <Radio.Button value="may" style={{ backgroundColor: `${size === 'may' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'may' ? 'white' : 'black'}`, borderColor: `${size === 'may' ? '#363743' : '#EBEBEC'}` }}>May<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="apr" style={{ backgroundColor: `${size === 'apr' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'apr' ? 'white' : 'black'}`, borderColor: `${size === 'apr' ? '#363743' : '#EBEBEC'}` }}>Apr<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="mar" style={{ backgroundColor: `${size === 'mar' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'mar' ? 'white' : 'black'}`, borderColor: `${size === 'mar' ? '#363743' : '#EBEBEC'}` }}>Mar<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="feb" style={{ backgroundColor: `${size === 'feb' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'feb' ? 'white' : 'black'}`, borderColor: `${size === 'feb' ? '#363743' : '#EBEBEC'}` }}>Feb<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="jan" style={{ backgroundColor: `${size === 'jan' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'jan' ? 'white' : 'black'}`, borderColor: `${size === 'jan' ? '#363743' : '#EBEBEC'}` }}>Jan<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="dec" style={{ backgroundColor: `${size === 'dec' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'dec' ? 'white' : 'black'}`, borderColor: `${size === 'dec' ? '#363743' : '#EBEBEC'}` }} >Dec<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="nov" style={{ backgroundColor: `${size === 'nov' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'nov' ? 'white' : 'black'}`, borderColor: `${size === 'nov' ? '#363743' : '#EBEBEC'}` }}>Nov<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="oct" style={{ backgroundColor: `${size === 'oct' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'oct' ? 'white' : 'black'}`, borderColor: `${size === 'oct' ? '#363743' : '#EBEBEC'}` }} >Oct<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="sep" style={{ backgroundColor: `${size === 'sep' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'sep' ? 'white' : 'black'}`, borderColor: `${size === 'sep' ? '#363743' : '#EBEBEC'}` }} >Sep<br /> <span className='fort-year'>2023</span></Radio.Button>
                            <Radio.Button value="aug" style={{ backgroundColor: `${size === 'aug' ? '#00305F' : '#F1F6FD'}`, color: `${size === 'aug' ? 'white' : 'black'}`, borderColor: `${size === 'aug' ? '#363743' : '#EBEBEC'}` }}>Aug<br /> <span className='fort-year'>2023</span></Radio.Button>

                        </Radio.Group>
                        <Dropdown
                            menu={{
                                items,
                            }}
                            placement="bottom"
                        >
                            <Button className='month-btn1'>FY 2020-21</Button>
                        </Dropdown>
                    </div> */}
                    {/* <div className='flex justify-between mt-2'>
                        <div className='mo-bo flex justify-between'>
                            <div className='back-200'>
                                <p className='p-200'>200</p>
                                <p className='mo-con'>Total Request this month</p>
                            </div>
                            <div className='back-200 ml-2'>
                                <p className='p-200'>100</p>
                                <p className='mo-con'>Approved</p>
                            </div>
                            <div className='back-200 ml-2'>
                                <p className='p-200'>50</p>
                                <p className='mo-con'>Rejected</p>
                            </div>
                            <div className='back-200 ml-2'>
                                <p className='p-200'>50</p>
                                <p className='mo-con'>Pending</p>
                            </div>
                        </div>

                        <div>
                            v
                        </div>

                    </div> */}
                                        <div className='ag-theme-alpine text-base border-none font-proxima tableBordered firstColLeft [&_.ag-header-cell-text]:!text-center [&_.ag-header-cell-text]:w-full' style={{  width: '100%', marginTop: '10px' }}>

                      <AgGridReact
       ref={gridRef}
       gridOptions={gridOptions}
        columnDefs={columnDefs}
        rowData={rowdata}
        domLayout='autoHeight'
        // onGridReady={(params) => setGridApi(params.api)}
        pagination={true}
        getRowHeight={() => 60}
        paginationPageSize={20}
      />
      </div>
                    {/* <div className='month-table mt-2'>
                        <Table
                            columns={columns}
                            dataSource={data}
                            pagination={false}
                            bordered
                            size='small'
                        />
                    </div> */}
                </Col>
            </Row>

        </>

    )
}

export default MonthlyHistory